import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { TYPES, EDITOR_PANELS } from 'crazyEditor/core/constants/panelConstants';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import _ from 'lodash';
import { openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import {getSellerId} from '../../MyAccount/Listings/EbayListing/ebayListingSelectors';
import {addDynamicDialog} from '../../crazyEditor/redux/modules/panel/panel';
import ReAuthenticateEbayAccountDialog from '../components/Dialogs/ReAuthenticateEbayAccountDialog/ReAuthenticateEbayAccountDialog';

@connectWithRouter(
  state => {
    const accounts = state.accountPage.accounts;
    const sellerId = getSellerId(state);
    return ({
      ebayConnected: !_.isEmpty(accounts),
      publishAction: state.user.planDetails.publishAction,
      tempUser: state.user.tempUser,
      oAuthToken: accounts[sellerId] && accounts[sellerId].oAuthToken,
      sellerId: getSellerId(state),
    });
  }, {openLazyPanel, addDynamicDialog}, {overrideLocationProtection: true}
)
export default class UtilsProvider extends Component {
  static childContextTypes = {
    utils: PropTypes.object,
  };

  getChildContext = () => {
    return { utils: this };
  };

  // The changes to the code that supports temp users can be found in the following commits:
  // c3c88f2eec0c87ef1eec800e050989f30e38b620
  // 1511f0c5503141ae4986be86179caef8f5be57d7
  verifyUserStatusAndCall = (func, oAuthVerification = false) => {
    const {openLazyPanel, ebayConnected, publishAction, oAuthToken, addDynamicDialog, sellerId} = this.props;
    if (ebayConnected) {
      if (publishAction === 'UPGRADE') {// limit reached
        openLazyPanel(EDITOR_PANELS.LIMIT_REACHED, TYPES.EDITOR_PANEL);
      } else if (publishAction === 'EXPIRED') {
        openLazyPanel(EDITOR_PANELS.TRIAL_EXPIRED, TYPES.EDITOR_PANEL);
      } else if (!oAuthToken && oAuthVerification) {
        addDynamicDialog(ReAuthenticateEbayAccountDialog, {action: func, sellerId});
      } else { // limit not reached, allow publish
        return func();
      }
    } else { // new ebay connection
      openLazyPanel(EDITOR_PANELS.CONNECT_EBAY, TYPES.EDITOR_PANEL, null, {onSuccess: func});
    }
  };

  render() {
    return this.props.children;
  }
}